module.exports = __webpack_public_path__ + "static/media/MinuteMail_Logo-03_1590163208745.2d940f4b.png";